import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MdbTableDirective, MdbTablePaginationComponent } from 'angular-bootstrap-md';
import { AlertService } from 'ngx-alerts';
import { environment } from '../../environments/environment';
import { ComprasService } from '../compras.service';
import { Comprobante } from '../comprobante';
import { ComprobanteService } from '../comprobante.service';
import { Factura } from '../Factura';
import { FacturaService } from '../factura.service';
import { PedidoDetalle } from '../PedidoDetalle';
import { PedidoEntidad } from '../PedidoEntidad';
import { Pedidos } from '../pedidos';
import { PedidosService } from '../pedidos.service';

@Component({
  selector: 'app-pedidos',
  templateUrl: './pedidos.component.html',
  styleUrls: ['./pedidos.component.css']
})
export class PedidosComponent implements OnInit {
  popoverTitle = 'Popover title';
  popoverMessage = 'Popover description';
  confirmClicked = false;
  cancelClicked = false;
  fecha: string;
  lista: Pedidos[]=[];
  factura: Factura;
  facturas: Factura[]= [];
  listPedido: PedidoEntidad[]= [];
  facturasRespuesta: Factura[];
  pedidoEntidad:PedidoEntidad;
  listaDetalle:PedidoDetalle[];
  previous: any = [];
  comprobante:Comprobante[];
  numeroDocumento:string;
  porcentajeIva: number;
  @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;
  
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective

  constructor(    private apiCompobante:ComprobanteService,  private apiFac: FacturaService,private datePipe: DatePipe,private alertService: AlertService,private api: PedidosService, private cdRef: ChangeDetectorRef, private formBuilder: FormBuilder, private ruter: Router) { }
  searchText: string = '';
  @HostListener('input') oninput() {
    this.searchItems();
  }

  PadLeft(value, length) {
    return (value.toString().length < length) ? this.PadLeft("0" + value, length) : 
    value;
  }
  ngOnInit(): void {
    this.porcentajeIva = 0.0;
  }


  searchItems() {
    const prev = this.mdbTable.getDataSource();

    if (!this.searchText) {
      this.mdbTable.setDataSource(this.previous);
      this.lista = this.mdbTable.getDataSource();
    }

    if (this.searchText) {
      this.lista = this.mdbTable.searchLocalDataBy(this.searchText);
      this.mdbTable.setDataSource(prev);
    }
  }


  agregar()
  {
    this.ruter.navigate(['detallecompras']);
    
  }

  anularegreso()
  {
    if(confirm("Está seguro de anular la compra")) {
      if(confirm("Se genera un nuevo egreso por devoluciòn.....")) {
      console.log("Implement delete functionality here");
    }
  }

  }

  ver(entidad: Pedidos){
    this.ruter.navigate(['verpedido' ,{ id: entidad.id }]);
  }


  procesarFactura(entidad: Pedidos)
  {
   
        this.api.buscarPedido(entidad.id)
      .subscribe((
        data: PedidoEntidad) => {
  
        this.pedidoEntidad = data;
        this.api.buscarPedidoDetalle(entidad.id)
        .subscribe((
          data: PedidoDetalle[]) => {
    
          this.listaDetalle = data;
          if(confirm("Está seguro de facturar")) {
            if(confirm("Desea generar Factura")) {
                  this.porcentajeIva=0.12;
                  this.apiCompobante.secuenciaComprobante(localStorage.getItem('id'),"F")
                  .subscribe((
                  data:Comprobante[]) => {
                  this.comprobante = data;
                  this.comprobante.forEach(element => {
                  this.numeroDocumento=this.PadLeft(element.secuencial,9);

                  });
                  this.pedidoEntidad.det=this.listaDetalle;
                  this.pedidoEntidad.numeroFactura=  this.numeroDocumento
                 // this.grabarFactura(this.pedidoEntidad,"F")
                  }
                  , err => {
                  console.log(err);

                  });

              

            }else{
              this.porcentajeIva=0.12;
              this.apiCompobante.secuenciaComprobante(localStorage.getItem('id'),"R")
              .subscribe((
              data:Comprobante[]) => {
              this.comprobante.forEach(element => {
              this.numeroDocumento=this.PadLeft(element.secuencial,9);

              });
              this.pedidoEntidad.det=this.listaDetalle;
              this.pedidoEntidad.numeroFactura=  this.numeroDocumento
              this.grabarFactura(this.pedidoEntidad,"R")
              }
              , err => {
              console.log(err);

              });
            }

          }
         
        },
          err => this.alertService.danger('Error no hay  conexion..')
        );
      },
        err => this.alertService.danger('Error no hay  conexion..')
      );

    
  
  }

  eliminar(entidad: Pedidos){
    if(confirm("Está seguro de eliminar el Pedido")) {
   this.api.eliminar(entidad.id).subscribe(

    data  => {
      this.alertService.success("Se elimino con exito..");
      this.buscar();
    
    },
    
    error  => {
    
   this.alertService.danger(error);
    
    }
    
    );
  }

  }
  grabarFactura(fac:Factura,tipo:string)
  {
  this.factura= new Factura();

    this.factura.tipoDoc=tipo;
    this.factura.id=0;
   
    this.factura.total=fac.total
    this.factura.totalConImpuestos=fac.totalConImpuestos
    this.factura.idCliente=fac.idCliente
    this.factura.idEmisor=Number(localStorage.getItem('id'));
    this.factura.idFormaPago=fac.idFormaPago
    this.factura.totalIva=fac.totalIva;
    this.factura.totalSinImpuestos=fac.totalSinImpuestos;
    this.factura.totalDescuentos=fac.totalDescuentos;
    this.factura.valorEfectivo=fac.valorEfectivo;
    this.factura.valorTarjeta=fac.valorTarjeta; 
    this.factura.numeroFactura=fac.numeroFactura; 
    
  this.factura.det=fac.det;
  this.facturas[0]=this.factura;
    this.apiFac.setActulizarFactura(this.facturas).subscribe(
      ( data: Factura[])  => {
      this.facturasRespuesta=data;
      let idFac=this.facturasRespuesta[0].id;
      this.pedidoEntidad.idFactura=idFac;
        this.listPedido[0]=this.pedidoEntidad;
     
      this.api.setActulizar(this.listPedido).subscribe(

        data  => {
         this.buscar();  
        },
        
        error  => {
        
       this.alertService.danger(error)
        
        }
        
        );
    
  
  

      //console.log(data);
      this.alertService.info('Se genero con exito...');
      let url=environment.apiReportes+"factura.rptdesign&__format=pdf&id="+idFac;
       
      //const printContent = document.getElementById(cmpName);
      //let doc = new jsPDF();
      //const pdfTable = this.content.nativeElement;
     //     doc.html(printContent, {callback: () => {
     //   doc.output('dataurlnewwindow');
    // }});
  
   //window.open(URL.createObjectURL(doc.output("blob")));
      const WindowPrt =   window.open(url, '', 'left=0,top=0,width=800,height=500,toolbar=0,scrollbars=0,status=0');
   
      //    window.open(URL.createObjectURL(doc.output("blob")));
   //   window.open('', '', 'left=0,top=0,width=800,height=500,toolbar=0,scrollbars=0,status=0');
     //WindowPrt.document.write('');
     // WindowPrt.print();
      },
          error  => {
      
        this.alertService.warning(error);
      
      }
      
      );
  }
  
  

  buscar() {

    this.api.getPedidos(this.datePipe.transform(this.fecha, "dd-MM-yyyy"),localStorage.getItem('id'))
      .subscribe((
        data: Pedidos[]) => {

        this.lista = data;
        console.log(this.lista);
        this.mdbTable.setDataSource(this.lista);
        this.mdbTable.dataSourceChange();
        this.previous = this.mdbTable.getDataSource();
      },
        err => this.alertService.danger('Error no hay  conexion..')
      );
  }


}
